'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ListPoliciesPage$() {
}
export { $c_Lpresto_ListPoliciesPage$ as $c_Lpresto_ListPoliciesPage$ };
$p = $c_Lpresto_ListPoliciesPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListPoliciesPage$;
/** @constructor */
function $h_Lpresto_ListPoliciesPage$() {
}
export { $h_Lpresto_ListPoliciesPage$ as $h_Lpresto_ListPoliciesPage$ };
$h_Lpresto_ListPoliciesPage$.prototype = $p;
$p.dl = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1017254947);
});
$p.l = (function() {
  return "ListPoliciesPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "ListPoliciesPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_ListPoliciesPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListPoliciesPage$, "presto.ListPoliciesPage$", ({
  Lk: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_ListPoliciesPage$ as $d_Lpresto_ListPoliciesPage$ };
var $n_Lpresto_ListPoliciesPage$;
function $m_Lpresto_ListPoliciesPage$() {
  if ((!$n_Lpresto_ListPoliciesPage$)) {
    $n_Lpresto_ListPoliciesPage$ = new $c_Lpresto_ListPoliciesPage$();
  }
  return $n_Lpresto_ListPoliciesPage$;
}
export { $m_Lpresto_ListPoliciesPage$ as $m_Lpresto_ListPoliciesPage$ };
//# sourceMappingURL=presto.-List-Policies-Page$.js.map
